import { Skeleton } from "@mui/material";
import clsx from "clsx";

interface TokenCardProps {
  icon: string;
  tokenName: string;
  tokenValue: string;
  leadingText?: JSX.Element | string;
  iconAlt: string;
  valueColor?: string;
  actionButton?: JSX.Element;
  isLoading?: boolean;
}

export default function TokenCard(props: TokenCardProps) {
  return (
    <div className="flex items-center justify-between shadow-sm p-2 bg-white rounded min-h-[60px] md:min-h-[81px]">
      <div className="flex items-center space-x-2 md:space-x-4">
        <img src={props.icon} alt={props.iconAlt} className="w-8 h-8 md:w-10 md:h-10 object-contain" />
        <div className="flex flex-col">
          <div className="text-xs md:text-sm font-medium leading-[1.2]">{props.tokenName}</div>
          {props.isLoading ? (
            <Skeleton className="rounded my-1" sx={{ bgcolor: "#e2e2e2" }} variant={"rectangular"} height={24} width={160} />
          ) : (
            <div
              className={clsx("font-bold text-xl md:text-2xl leading-[1.2]", {
                "text-primary": props.valueColor === "primary",
                "text-mtvx-eth": props.valueColor === "eth",
              })}
            >
              {props.tokenValue}
            </div>
          )}
          <div className="flex space-x-3 items-center text-sm md:text-base font-medium text-[#656565] leading-[1.2]">
            {props.leadingText}
          </div>
        </div>
      </div>
      {props.actionButton ? props.actionButton : <div className="w-32" />}
    </div>
  );
}
